export default __webpack_public_path__ + "static/media/maketheworldsee.0f24f931.svg";